import { BOOKING_FR_FR } from "./booking";
import { eventReports } from "./event-reports";

export const event = {
	booking: BOOKING_FR_FR,
	...eventReports,
};
